module.exports = __webpack_public_path__ + "static/media/payment-methods.44e439de.png";